import { CoreEnums } from '@/utils/domain/constants';

const DISCOUNT_TYPE_API = Object.freeze({
  [CoreEnums.CustomerDiscountType.Percentage]: 'percentage',
  [CoreEnums.CustomerDiscountType.FixedAmount]: 'fixed-amount',
});

const FREQUENCY_TYPE_API = Object.freeze({
  [CoreEnums.CustomerDiscountFrequencyType.OneTime]: 'one-time',
  [CoreEnums.CustomerDiscountFrequencyType.Recurring]: 'recurring',
});

const CURRENCY_API = Object.freeze({
  [CoreEnums.Currency.USD]: 'USD',
});

const toIso = (value) => {
  if (value == null || value === '') return undefined;
  if (typeof value.toISOString === 'function') {
    const iso = value.toISOString();
    return iso || undefined;
  }
  const date = new Date(value);
  return Number.isNaN(date.getTime()) ? undefined : date.toISOString();
};

const unwrapId = (value) => {
  if (value && typeof value === 'object') return value.value ?? value.id ?? undefined;
  return value;
};

const hasText = (value) => typeof value === 'string' && value.trim() !== '';

export const unwrapList = (response) => {
  if (Array.isArray(response)) return response;
  if (Array.isArray(response?.items)) return response.items;
  if (Array.isArray(response?.data)) return response.data;
  return [];
};

export const isOpenAssignmentStatus = (status) =>
  status === CoreEnums.CustomerDiscountAssignmentStatus.Scheduled ||
  status === CoreEnums.CustomerDiscountAssignmentStatus.Active;

export const readNextCharge = (payload) => {
  if (!payload || typeof payload !== 'object' || Array.isArray(payload)) return null;
  return {
    baseNetAmount: payload.BaseNetAmount ?? payload.baseNetAmount ?? null,
    discountAmount: payload.DiscountAmount ?? payload.discountAmount ?? null,
    netAmount: payload.NetAmount ?? payload.netAmount ?? null,
    mrrAmount: payload.MrrAmount ?? payload.mrrAmount ?? null,
    discountAssignmentId: payload.DiscountAssignmentId ?? payload.discountAssignmentId ?? null,
  };
};

const readOptionValue = (value) => unwrapId(value);

export const toAgreementWriteRequest = (values = {}) => {
  const discountTypeRaw = readOptionValue(values.discountType);
  const frequencyTypeRaw = readOptionValue(values.frequencyType);
  const discountType = DISCOUNT_TYPE_API[discountTypeRaw] || discountTypeRaw;
  const frequencyType = FREQUENCY_TYPE_API[frequencyTypeRaw] || frequencyTypeRaw;
  const body = {
    name: typeof values.name === 'string' ? values.name.trim() : values.name,
    discountType,
    discountValue:
      values.discountValue === '' || values.discountValue == null
        ? values.discountValue
        : Number(values.discountValue),
    frequencyType,
  };

  if (hasText(values.description)) body.description = values.description.trim();

  if (discountType === 'fixed-amount') {
    const currencyRaw = readOptionValue(values.currency);
    const currency = CURRENCY_API[currencyRaw] || currencyRaw;
    if (currency) body.currency = currency;
  }

  if (
    frequencyType === 'recurring' &&
    values.durationPeriods != null &&
    values.durationPeriods !== ''
  ) {
    body.durationPeriods = Number(values.durationPeriods);
  }

  const effectiveFrom = toIso(values.effectiveFrom);
  const effectiveTo = toIso(values.effectiveTo);
  if (effectiveFrom) body.effectiveFrom = effectiveFrom;
  if (effectiveTo) body.effectiveTo = effectiveTo;

  return body;
};

export const toAssignmentRequest = (values = {}) => {
  const body = {
    agreementId: unwrapId(values.agreementId),
    companyBillingSubscriptionId: unwrapId(values.companyBillingSubscriptionId),
    effectiveFrom: toIso(values.effectiveFrom),
    effectiveTo: toIso(values.effectiveTo) || null,
  };
  return body;
};
